import { axiosMockAdapterInstance } from "apis/index";
import { getResponseData } from "./index";

export const data = {
  statusCode: 200,
  time: "2022-06-02T09:14:49.838Z",
  transactions: [
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.00065907,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      amount: "25000",
      feeAmount: "0.00070871",
      transactionHash: "0xcefe46bfd8696f7dcf6992ba378e5e925b2a94d298f0d423866cd787fe9ed1c3",
      blockTimestamps: "2022-06-01T08:11:29.000Z",
      event: "flushToMerchant",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.00180499,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      transactionHash: "0x9b9d3a75758e5a11f37528671dd55c7ce2a26f81ccf5f22ecef271bf48b9143d",
      blockTimestamps: "2022-06-02T10:49:38.000Z",
      event: "initFPMerchant",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0xe0c209b96cfc112121e3379d71445e5645370432",
      network: "binance-smart-chain-testnet",
      gasFee: 0.0008635,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      amount: "0",
      transactionHash: "0x69df2954fb7853d708b5f02190a3ff8af35c5213da4d011780314e7a3d1d2e8e",
      blockTimestamps: "2022-05-18T09:25:38.000Z",
      event: "other",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.00056063,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      amount: "1.000582836882785555",
      feeAmount: "0",
      transactionHash: "0x188df6e8ff61c99244903b3d74d8a719e89fe7b3a0f5952505be356a7af43b37",
      blockTimestamps: "2022-05-31T10:14:48.000Z",
      event: "resolveUnlinkedPaymentForFPMerchant",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.00034892,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      amount: 19,
      transactionHash: "0x496cd6e99b2206869633220fd4bd9b85b203615bde3baf5d817e33666b6e7e66",
      blockTimestamps: "2022-06-03T04:07:47.000Z",
      event: "setupServiceFeeForFPMerchant",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.00029049,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      amount: "19000",
      transactionHash: "0x9728f5c63f3c5ac2f2908a7c683d74cb9255dc3fc839764fa6aa57024360f679",
      blockTimestamps: "2022-06-02T08:20:05.000Z",
      event: "updateDefaultServiceFee",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.00038863,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      transactionHash: "0x290ab7930286f103f7ad0084090828a6f598745c25a05519f88b2215acfc87a6",
      blockTimestamps: "2022-06-02T11:00:08.000Z",
      event: "updateMerchantClose",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.0005803000000000001,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      amount: "2.00116567376557111",
      transactionHash: "0x4b9278d8a7a620fcc5fcccf7453d2f162523b4ba1df19a5c00c4fdc2904c1567",
      blockTimestamps: "2022-06-02T07:46:41.000Z",
      event: "withdrawTokenServiceFeeToAdmin",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.0005803000000000001,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      amount: "2.00116567376557111",
      transactionHash: "0x4b9278d8a7a620fcc5fcccf7453d2f162523b4ba1df19a5c00c4fdc2904c1567",
      blockTimestamps: "2022-06-02T07:46:41.000Z",
      event: "withdrawTokenServiceFeeToAdmin",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.0005803000000000001,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      amount: "2.00116567376557111",
      transactionHash: "0x4b9278d8a7a620fcc5fcccf7453d2f162523b4ba1df19a5c00c4fdc2904c1567",
      blockTimestamps: "2022-06-02T07:46:41.000Z",
      event: "withdrawTokenServiceFeeToAdmin",
      merchantContract: "Abc",
    },
    {
      from: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      to: "0x463af0c60a4bfc8cdb5ea52b9cb4a1102d315b53",
      network: "binance-smart-chain-testnet",
      gasFee: 0.0005803000000000001,
      token: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      tokenGas: { name: "BNB", network: "binance-smart-chain-testnet", slug: "bnb-bsc" },
      amount: "2.00116567376557111",
      transactionHash: "0x4b9278d8a7a620fcc5fcccf7453d2f162523b4ba1df19a5c00c4fdc2904c1567",
      blockTimestamps: "2022-06-02T07:46:41.000Z",
      event: "withdrawTokenServiceFeeToAdmin",
      merchantContract: "Abc",
    },
  ],
  total: 11,
};

export const onGet = (query) => {
  let { page, limit, event, to, from, merchantContract } = query;
  let dataQuery = data.transactions;
  let total = data.total;
  if (event) {
    dataQuery = data.transactions.filter((x) => x.event === event);
    total = dataQuery.length;
  }
  if (to) {
    dataQuery = data.transactions.filter((x) => x.to === to);
    total = dataQuery.length;
  }
  if (from) {
    dataQuery = data.transactions.filter((x) => x.from === from);
    total = dataQuery.length;
  }
  if (merchantContract) {
    dataQuery = data.transactions.filter((x) => x.merchantContract === merchantContract);
    total = dataQuery.length;
  }
  axiosMockAdapterInstance.onGet("operator-transactions").reply(() => {
    let res = dataQuery.filter((x, index) => index < page * limit && index >= (page - 1) * limit);
    let data = res;
    return [200, getResponseData(data, total)];
  });
};
